import { useState } from "react";
import { NavLink } from "react-router-dom";
import { Menu, Phone, X } from "lucide-react";
import { Logo } from "@/components/site/Logo";
import { InstallAppButton } from "@/components/site/InstallApp";
import { BRAND, MENU, waLink } from "@/lib/content";

const slug = (s) => s.toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "").replace(/[^a-z0-9]+/g, "-");

const NavItems = ({ onClick, vertical }) => (
  <>
    {MENU.map((m) => (
      <NavLink key={m.to} to={m.to} end={m.to === "/"} onClick={onClick} data-testid={`nav-link-${slug(m.label)}`}
        className={({ isActive }) =>
          `font-heading text-[13px] font-semibold uppercase tracking-wide transition-colors duration-200 ${vertical ? "block border-b border-slate-800 py-3" : "px-2 py-1"} ${isActive ? "text-red-500" : "text-slate-300 hover:text-white"}`}>
        {m.label}
      </NavLink>
    ))}
  </>
);

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="no-print sticky top-0 z-40 border-b border-slate-800 bg-[#0B0F17]/90 backdrop-blur-md">
      <div className="border-b border-slate-800/80 bg-black/60">
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-1.5 font-mono text-[11px] uppercase tracking-wider text-slate-400 sm:px-6">
          <span>Atendimento: {BRAND.atendimento}</span>
          <a href={waLink()} target="_blank" rel="noreferrer" data-testid="topbar-phone-link" className="flex items-center gap-1.5 text-white hover:text-red-400">
            <Phone className="h-3 w-3 text-red-500" /> WhatsApp {BRAND.telefone}
          </a>
        </div>
      </div>
      <div className="mx-auto flex max-w-7xl items-center justify-between gap-4 px-4 py-3 sm:px-6">
        <Logo />
        <nav className="hidden flex-wrap items-center justify-end gap-x-1 gap-y-1 xl:flex">
          <NavItems />
        </nav>
        <div className="flex items-center gap-2 xl:hidden">
          <InstallAppButton className="hidden sm:inline-flex" />
          <button className="p-2 text-white" onClick={() => setOpen(!open)} data-testid="mobile-menu-toggle" aria-label="Menu">
            {open ? <X /> : <Menu />}
          </button>
        </div>
      </div>
      {open && (
        <nav className="max-h-[75vh] overflow-y-auto border-t border-slate-800 bg-[#0B0F17] px-6 pb-6 xl:hidden" data-testid="mobile-menu">
          <NavItems vertical onClick={() => setOpen(false)} />
          <InstallAppButton className="mt-5 w-full" />
        </nav>
      )}
    </header>
  );
};
